export const nullifyEmptyStringValues = (obj: Record<string, unknown>) => {
  let values = { ...obj };
  Object.keys(values).forEach(key => {
    const keyWithType = key as keyof typeof values;
    const value = values[keyWithType];
    values = { ...values, [keyWithType]: value === "" ? null : value };
  });
  return values;
};
